import { render, staticRenderFns } from "./AppPagination.vue?vue&type=template&id=49c8bc06&scoped=true&"
import script from "./AppPagination.vue?vue&type=script&lang=ts&"
export * from "./AppPagination.vue?vue&type=script&lang=ts&"
import style0 from "./AppPagination.vue?vue&type=style&index=0&id=49c8bc06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c8bc06",
  null
  
)

export default component.exports